/* @jsx h */
import { defineComponent, h, PropType } from "vue";

export const PrintTemplatePreviewPane = defineComponent({
  name: "PrintTemplatePreviewPane",
  props: {
    svg: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String as PropType<string | null>,
      default: null,
    },
  },
  setup(props) {
    return () => (
      <>
        <style>{`
          .preview-svg-frame {
            background: #ffffff;
          }

          .preview-svg-frame svg {
            display: block;
            width: 100%;
            height: auto;
            max-width: 100%;
            background: #ffffff;
          }
        `}</style>
        <div class="flex h-full min-h-0 flex-col border-l  bg-base-200/30">
          <div class="border-b  px-6 py-4">
            <h3 class="text-sm font-semibold uppercase tracking-[0.18em] text-base-content/50">
              Preview
            </h3>
            <p class="mt-1 text-sm text-base-content/70">
              Live SVG output from the print template preview endpoint.
            </p>
          </div>
          <div class="flex-1 overflow-y-auto p-6">
            {props.isLoading ? (
              <div class="mx-auto flex w-full max-w-[460px] flex-col gap-4 rounded-[28px] border  bg-base-100 p-5 shadow-sm">
                <div class="animate-pulse space-y-4">
                  <div class="h-4 w-20 rounded bg-base-300/70"></div>
                  <div class="h-8 w-48 rounded bg-base-300/60"></div>
                  <div class="h-4 w-28 rounded bg-base-300/50"></div>
                  <div class="h-64 rounded-2xl bg-base-200"></div>
                </div>
              </div>
            ) : props.error ? (
              <div class="mx-auto max-w-sm rounded-2xl border border-error/20 bg-error/5 px-5 py-4 text-sm text-error">
                {props.error}
              </div>
            ) : props.svg ? (
              <div
                class="preview-svg-frame mx-auto w-full max-w-[460px] overflow-hidden rounded-[28px] border  bg-white p-4 shadow-sm"
                v-html={props.svg}
              ></div>
            ) : (
              <div class="mx-auto max-w-sm rounded-2xl border  bg-base-100 px-5 py-8 text-center text-sm text-base-content/60">
                Preview will appear here once the editor has enough content.
              </div>
            )}
          </div>
        </div>
      </>
    );
  },
});
